// removed by extract-text-webpack-plugin
module.exports = {"Header":"_yP1Gp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Headers/AddonsHeader/AddonsHeader.scss
// module id = 558
// module chunks = 0